export enum CommandsActions {
  PowerOn = 'powerOn',
  PowerOff = 'powerOff',
  MinMaxPressure = 'minMaxPressure',
  MinMaxTargetPressure = 'minMaxTargetPressure',
  TargetAutoStopImmediateStopPressure = 'targetAutoStopImmediateStopPressure',
  Load = 'load',
  Unload = 'unload',
  PressureBandSelection = 'pressureBandSelection',
  ModulationOn = 'modulationOn',
  ModulationOff = 'modulationOff',
  EcoplantControlOn = 'ecoplantControlOn',
  EcoplantControlOff = 'ecoplantControlOff',
  ContinuousModeOn = 'continuousModeOn',
  ContinuousModeOff = 'continuousModeOff',

  // new actions
  TargetPsi = 'targetPsi',
  TargetBar = 'targetBar',
  LoadUnloadPsi = 'loadUnloadPsi',
  LoadUnloadBar = 'loadUnloadBar',
  LoadUnloadTargetPsi = 'loadUnloadTargetPsi',
  LoadUnloadTargetBar = 'loadUnloadTargetBar',
  AutoImmediateTargetPsi = 'autoImmediateTargetPsi',
  AutoImmediateTargetBar = 'autoImmediateTargetBar',
  LoadTargetPsi = 'loadTargetPsi',
  LoadTargetBar = 'loadTargetBar',
  UnloadTargetPsi = 'unloadTargetPsi',
  UnloadTargetBar = 'unloadTargetBar',
  AutoHotStartPsi = 'autoHotStartPsi',
  AutoHotStartBar = 'autoHotStartBar',
}
